import { render } from "./GenericSnackBar.vue?vue&type=template&id=34ffcbae"
import script from "./GenericSnackBar.vue?vue&type=script&lang=js"
export * from "./GenericSnackBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__